import resourceEws from './resource-ews'
import resourceDb from './resource-db'
import resource from './resource'
import ewsCalendar from './ews-calendar'


export default{
    resourceEws,
    resourceDb,
    resource,
    ewsCalendar
}